import React from "react";
import Box from "@mui/material/Box";
import { Button, DialogActions, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";

export function ConfirmDeletionPopup({
  children,
  onCancel,
  onConfirm,
}: {
  children: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Box>
      <DialogTitle>{children}</DialogTitle>

      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button color={"error"} onClick={() => onConfirm()} variant={"contained"}>
          Delete
        </Button>
      </DialogActions>
    </Box>
  );
}
